import React, { useEffect } from "react";
import curveLine from "../assets/curveLine.png";
import AOS from 'aos';
import 'aos/dist/aos.css';
const features = [
  {
    number: "01",
    title: "Guardian-Centred Process:",
    description:
      "At My Wali, we recognise the vital role guardians play in the journey of finding a spouse. Whether a guardian is leading the process, or a seeker is taking the initiative, we place guardians at the core of every connection, ensuring their support, wisdom, and guidance remain integral throughout the entire journey.",
  },
  {
    number: "02",
    title: "Faith-Centred Connections:",
    description:
      "Every connection at My Wali is rooted in Islamic values, ensuring your journey to find the perfect match is entirely halal. We strictly adhere to Islamic guidelines to avoid haram interactions and maintain the sincerity of each member’s intentions. Unlike mainstream marriage apps, our faith-driven approach offers a unique, principled experience, making it easier to find a partner who aligns with your values.",
  },
  {
    number: "03",
    title: "Meaningful Connections:",
    description:
      "We emphasise quality over quantity by prioritising the depth and sincerity of your interactions. To foster meaningful connections, users are limited to interacting with five active matches at a time, encouraging genuine investment in each potential relationship. This approach allows for the cultivation of deeper, more meaningful connections. When you're ready to explore new connections, simply unconnect to make room for others, promoting transparency and clarity throughout the process.",
  },
  {
    number: "04",
    title: "Approved Seeker Interaction:",
    description:
      "We recognise the importance of family involvement and the need to connect with your potential spouse on a personal level. That’s why My Wali offers both private chat and group chat features, ensuring full transparency between seekers and guardians. Private chats allow seekers to get to know each other through direct messaging, all within the boundaries of Islamic principles. This collaborative approach ensures that conversations remain respectful, with active family participation, and are fully aligned with Islamic values.",
  },
  {
    number: "05",
    title: "Fully Verified Guardian Profiles:",
    description:
      "We prioritise the verification of guardian profiles, placing them at the heart of the matchmaking process. Unlike mainstream apps that focus primarily on seeker verification, we rigorously vet each guardian, reducing the chances of dishonest intentions. This emphasis on guardian involvement enhances safety and upholds the halal principles of our platform, setting us apart in our dedication to preserving the integrity of the marriage process. By ensuring guardians are active participants, we create a transparent and trustworthy environment that aligns with Islamic values, giving families peace of mind and confidence as they seek a compatible, faith-driven match.",
  },
  {
    number: "06",
    title: "Complete Privacy:",
    description:
      "We prioritise your privacy and discretion throughout your search. Profile pictures are optional, but when engaging with a match, users have an option to upload a photo that can be viewed only once. This feature, available within the secure messenger portal, ensures your experience remains private. Additionally, you can choose to blur your profile picture and stay hidden from potential matches within a specific radius, allowing you to explore connections with confidence—free from concerns about revealing your search to those in your local community.",
  },
  {
    number: "07",
    title: "Personalised and Tailored Matches:",
    description:
      "We understand that your journey to find the perfect connection is unique. Our advanced algorithm is designed to provide you with personalised and tailored matches based solely on your specific preferences and values. By focusing on what matters most to you, we ensure that every potential connection aligns with your expectations, making your search more meaningful and efficient.",
  },
  {
    number: "08",
    title: "A Community of Like-minded Families:",
    description:
      "At My Wali, you're not just joining an app—you’re becoming part of a supportive community of families who share your values and desires. Our platform connects you with like-minded individuals and guardians who are also seeking meaningful, faith-centred connections. By fostering a network grounded in shared Islamic principles, we create an environment where you can confidently explore potential matches, knowing that everyone is committed to upholding the same values of respect, trust, and sincerity.",
  },
];



function WhyChooseUs() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, [])
  return (
    <section id="why-us" className="w-full px-5 sm:px-10 md:px-20 lg:px-28 rounded-none py-16  bg-[#E5E2EC?] bg-white">
      <div className="flex gap-5 flex-col items-center justify-center">
      <header className="flex flex-col items-center text-3xl sm:text-4xl leading-none pb-10 pr-5">
              <h2 className="w-full text-center text-themeColor font-yeseva">
                Why Us
              </h2>
              <h3 className="mt-4 text-center text-[#0B0B19] font-sans font-semibold pb-5">
                Why Choose My Wali
              </h3>
              <div>
            <img src={curveLine} alt="" />
        </div>
            </header>
        <div className="mt-8 md:mt-0 w-full  md:w-[95%] mx-auto grid grid-cols-12 gap-y-10 sm:gap-y-10 sm:gap-10">
          {features.map((items, index) => (
            <FeatureCard
              number={index + 1}
              title={items.title}
              description={items.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;

function FeatureCard({ number, title, description }) {
  return (
    <div 
    data-aos="fade-up"
    className={`w-full col-span-12 md:col-span-6 ${number%2==0 ? "rounded-[40px_5px_40px_5px]" : "rounded-[5px_40px_5px_40px]" } border-[1.5px] font-sans text-black flex flex-col px-6 py-8  rounded-[40px_5px_40px_5px]  relative`}>
      <div className={` -top-8 z-10 px-3.5 text-xl ${number%2==0 ? "right-5" : "left-5" } text-center content-center font-yeseva text-white bg-secondColor rounded-full h-[60px] w-[60px] absolute`}>
        0{number}
      </div>
      <h4 className="self-start text-2xl font-sans font-semibold">{title}</h4>
      <p className="mt-2 text-[13px] leading-4 font-poppins">
        {description}
      </p>
    </div>
  );
}
